import axios from 'axios'
import URLS from '../../util/urls.js';

const state = {
  listaTipoConta: [],
  tipoContaPesquisa: {
    nome: undefined,
    pagina: 0
  },

  labelQuantidade: '',
  tipoContaSelecionado: {
    id: 0,
    nome: ''
  },
}

const mutations = {
  atualizarListaTipoConta(state, payload) {
    if(state.tipoContaPesquisa.pagina === 0) {
      state.listaTipoConta = payload.lista;
    } else {
      state.listaGrupoConta.push(...payload.lista);
    }

    state.labelQuantidade = payload.quantidade + (payload.quantidade == 1 ? " tipo de conta encontrado" : " tipos de conta encontrados");
  },

  limparTipoContaListadas(state) {
    state.listaTipoConta = [];
  },
  limparTipoContaPesquisa(state) {
    state.tipoContaPesquisa = {
      nome: undefined,
      pagina: 0
    }
  },

  atualizarTipoContaSelecionado(state, payload) {
    state.tipoContaSelecionado = payload;
  },

  novoTipoConta(state) {
    state.tipoContaSelecionado = {
      id: 0,
      nome: ''
    }
  },
}

const actions = {
  limparTipoContaListadas(context) {
    context.commit('limparTipoContaListadas');
  },

  novoTipoConta(context) {
    context.commit('novoTipoConta')
  },

  limparTipoContaPesquisa(context) {
    context.commit('limparTipoContaPesquisa')
  },

  gravarTipoConta(context, payload) {
    return axios.post(URLS.TIPO_CONTA_GRAVAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarTipoContaSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch('gravarTipoConta', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarTipoConta(context, payload) {
    return axios.post(URLS.TIPO_CONTA_RECUPERAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarTipoContaSelecionado', response.data.item);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('recuperarTipoConta', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  listarTipoConta(context, payload) {
    return axios.post(URLS.TIPO_CONTA_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaTipoConta', response.data);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch("listarTipoConta", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  removerTipoConta(context, payload) {
    return axios.post(URLS.TIPO_CONTA_REMOVER, payload)
    .then(response => {
      switch (response.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch("removerTipoConta", payload)
            }
          }).catch(error => {
            throw error
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  }
}

export default {
  state,
  mutations,
  actions
}